import {useEffect, useState} from 'react';
import {selfcareInvoices} from "../../util/request";
import {Invoice, Pagination, ProductInstance} from "../../util/types";
import {PaginationElement} from "./PaginationElement";
import {creditnoteStatus, invoiceStatus} from "../../util/translator";
import {formatAmountWithCurrency, formatDate} from "../../util/formatter";
import Icon from "./Icon";
import ErrorMessage from "./ErrorMessage";
import {useCustomer} from "../../layouts/SelfcareLayout";
import {Link} from "react-router-dom";
import LoaderSpinner from '../loaders/LoaderSpinner';
import Routing from "../../Routing.ts";
import IconArrow from "../icons/IconArrow.tsx";
import IconOpenInNew from "../icons/IconOpenInNew.tsx";
import IconDownload from "../icons/IconDownload.tsx";

export default function InvoiceTable(props: { customer_id: string, page: number }) {
    const [invoices, setInvoices] = useState<Invoice[]>([])
    const [pagination, setPagination] = useState<Pagination | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const loadingClass: string = loading ? "selfcare-loading-content" : "";

    const {customer} = useCustomer();
    const incomingInvoice = customer.product_instances.find((key: ProductInstance) => key.product_instance_status_active_date !== '9999-12-31')

    useEffect(() => {
        setLoading(true)
        selfcareInvoices(props.customer_id, props.page)
            .then(r => {
                setInvoices(r.response.data)
                setPagination(r.response.pagination)
            })
            .catch(() => {
                setError(true)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [props.customer_id, props.page])

    if (error) {
        return <ErrorMessage/>
    }

    if (pagination === null) {
        return <LoaderSpinner/>
    }

    if (pagination === undefined || (pagination.total_records === 0 && !incomingInvoice)) {
        return <p className='no-content'>Der er ingen regninger at vise.</p>
    }

    function getStatus(status: string, type: string, invoice_id: number) {
        if (invoice_id === -1) {
            return 'Kommende';
        }

        if (type === 'Kreditnota') {
            return creditnoteStatus(status);
        }

        return invoiceStatus(status);
    }

    return (
        <>
            <table className={`selfcare-invoices-table ${loadingClass}`}>
                <tbody>
                <tr>
                    <th>Regnings&shy;nummer</th>
                    <th>Type</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th colSpan={3}>Forfalds&shy;dato</th>
                </tr>
                {invoices.map((invoice) => {
                    let classNames = "";
                    classNames += invoice.type === 'Kreditnota' ? 'creditnote ' : '';
                    classNames += invoice.invoice_id === -1 ? 'next-invoice ' : ''
                    return (
                        <tr className={classNames} key={invoice.invoice_id}>
                            <td data-label='Regning nr.'>{invoice.invoice_id === -1 ? 'Næste regning' : invoice.invoice_id}</td>
                            <td data-label='Type'>{invoice.type}</td>
                            <td data-label='Total'>{formatAmountWithCurrency(invoice.sum, false)}</td>
                            <td data-label='Status'>{getStatus(invoice.status, invoice.type, invoice.invoice_id)}</td>
                            <td data-label='Forfaldsdato'>{invoice.due_date ? formatDate(invoice.due_date) : '-'}</td>
                            <td className='selfcare-invoices-table-button'>
                                {invoice.invoice_id === -1
                                    ?
                                    <Link to={Routing.Selfcare.NextBill} state={{from_url: Routing.Selfcare.Bills}}>
                                        <Icon component={IconArrow}/>
                                    </Link>
                                    :
                                    <>
                                        <a href={`/mit-hiper/regninger/vis/${props.customer_id}/${invoice.invoice_id}`} target={'_blank'}><Icon component={IconOpenInNew}/></a>
                                        <a href={`/mit-hiper/regninger/vis/${props.customer_id}/${invoice.invoice_id}`} download={invoice.invoice_id}><Icon component={IconDownload}/></a>
                                    </>
                                }
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <PaginationElement pagination={pagination}/>
        </>
    );
}
